const makeCancelable = (promise, onCancel) => {
  return {
    hasCanceled_: false,
    result: promise,
    cancel() {
      this.hasCanceled_ = true;
    },
    async then(resolve, reject) {
      let result = await promise;
      if (this.hasCanceled_) {
        if (onCancel && typeof onCancel === "function") {
          onCancel();
        }

        return resolve(
          {
            status: 499,
            isCanceled: true,
            result: result
          });
      }
      else {
        return resolve(result);
      }
    }
  };
};
export default makeCancelable;